module.exports = __webpack_public_path__ + "img/trash-2.6032a70a.svg";